import script from "./NumberField.vue?vue&type=script&setup=true&lang=js"
export * from "./NumberField.vue?vue&type=script&setup=true&lang=js"

import "./NumberField.vue?vue&type=style&index=0&id=a8788afe&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8788afe"]])

export default __exports__